export const FETCH_ALL = "FETCH_ALL";
export const UPDATE = "UPDATE";
export const SORT = "SORT";
export const CLEAR = "CLEAR";
export const UPDATE_CURRENT = "UPDATE_CURRENT";
export const PREVSONG = "PREV";
export const NEXTSONG = "NEXT";
export const PLAY = "PLAY";
export const PAUSE = "PAUSE";
export const REPEAT = "REPEAT";
export const REPEATSONG = "REPEATSONG";
export const UPDATEPLAYING = "UPDATEPLAYING";
export const SETSHUFFLE = "SETSHUFFLE";
export const SETNOTSHUFFLE = "SETNOTSHUFFLE";
//export const UPDATESONGINDEX = "UPDATESONGINDEX";
export const SETTOGGLEIMAGES = "SETTOGGLEIMAGES";